import { useState } from "react";
import uniqueId from "lodash/uniqueId";

export const useUniqueId = (prefix?: string): string => {
  const [id] = useState(uniqueId(prefix));
  return id;
};
